import {Component, Input, Output, EventEmitter, OnInit, signal, effect} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {Employee} from '../models/employee.model';
import {SickLeaveRequest, SickLeaveService} from '../services/sick-leave.service';
import {NotificationService} from '../services/notification.service';
import {DatevAuthStatusService} from '../services/datev-auth-status.service';
import {buildSickLeaveForm, attachEndDateValidator, buildSickLeaveRequest, getCurrentDate} from '../shared/sick-leave-form.util';

@Component({
    selector: 'app-employee-sick-leave-form-modal',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './employee-sick-leave-form-modal.component.html',
    styleUrls: ['./employee-sick-leave-form-modal.component.css'],
})
export class EmployeeSickLeaveFormModalComponent implements OnInit {
    @Input() employee: Employee | null = null;
    @Output() close = new EventEmitter<void>();

    sickLeaveForm: FormGroup;
    isSubmitting = signal<boolean>(false);
    successMessage = signal<string>('');
    errorMessage = signal<string>('');

    constructor(
        private fb: FormBuilder,
        private sickLeaveService: SickLeaveService,
        private notificationService: NotificationService,
        public datevAuthService: DatevAuthStatusService
    ) {
        this.sickLeaveForm = buildSickLeaveForm(this.fb);

        effect(() => {
            document.body.style.overflow = this.employee ? 'hidden' : 'auto';
        });
    }

    ngOnInit() {
        attachEndDateValidator(this.sickLeaveForm);
    }

    onSubmit() {
        if (this.sickLeaveForm.valid && this.employee && this.datevAuthService.getAuthStatus()()) {
            this.isSubmitting.set(true);

            const request: SickLeaveRequest = buildSickLeaveRequest(
                this.sickLeaveForm,
                Number(this.employee.datevEmployeeNumber)
            );

            this.sickLeaveService.createSickLeave(request)
                .subscribe({
                    next: () => {
                        this.isSubmitting.set(false);
                        this.successMessage.set('Krankmeldung wurde erfolgreich erstellt');
                        this.errorMessage.set('');
                        this.resetForm();
                    },
                    error: (error) => {
                        this.isSubmitting.set(false);
                        this.errorMessage.set(error.error?.message || 'Ein unerwarteter Fehler ist aufgetreten');
                        this.successMessage.set('');
                    }
                });
        }
    }

    resetForm() {
        this.sickLeaveForm.reset({
            startDate: getCurrentDate(),
            endDate: '',
            isFollowUp: false,
            mitAttest: false
        });
    }

    onClose() {
        this.successMessage.set('');
        this.errorMessage.set('');
        this.resetForm();
        this.close.emit();
    }

    loginDatev() {
        this.datevAuthService.loginDatev();
    }
}